/*
  tabLOVAS — sabit başlık geçişinde sayfanın zıplamasını önler
  13 Ağustos 2026

  SORUN (ölçüldü, tahmin değil):
    scrollY  ~30 : .header_bottom  position:relative, yükseklik 60
                   .header-default yükseklik 60, belge yüksekliği 8444
    scrollY  ~60 : .header_bottom  .sticky sınıfını alıp position:fixed oluyor
                   .header-default yükseklik 0,  belge yüksekliği 8384

    Yani başlık akıştan çıkınca ebeveyni 60px çöküyor, belge 60px kısalıyor ve
    altındaki her şey bir anda 60px yukarı sıçrıyor. Kullanıcının gördüğü
    "biraz kaydırınca sayfa aşağı atıyor" bu.

  ÇÖZÜM:
    Başlığın kapladığı yer .header-default üzerinde min-height ile rezerve
    ediliyor. Başlık fixed'e geçtiğinde boşluk yerinde kaldığı için belge
    yüksekliği değişmiyor, sıçrama olmuyor.

    Yükseklik SABİT YAZILMADI — ölçülüyor. Duyuru çubuğu, ikinci menü satırı
    ya da masaüstü/mobil farkı yüksekliği değiştirebiliyor.

  GERİ ALMA: bu dosyayı sil + theme.liquid'deki script satırını kaldır.
  JS çalışmazsa davranış bugünküyle aynı olur — regresyon riski yok.
*/
(function () {
  'use strict';

  function kur() {
    var baslik = document.querySelector('.header_bottom');
    if (!baslik) return;
    var kap = baslik.parentElement; /* .header-default */
    if (!kap) return;

    var dogalYukseklik = 0;

    /* DİKKAT: başlık sabitlenince YÜKSEKLİĞİ DE DEĞİŞİYOR.
       Ölçüldü — mobil 60 → 60 (aynı), masaüstü 93 → 81 (12px kısalıyor).
       Bu yüzden rezerv DAİMA akıştaki (sabit olmayan) yükseklikten alınır;
       sabit haldeki ölçüyle güncellenirse masaüstünde 12px'lik yeni bir
       sıçrama doğuyor. İlk yazımdaki hata buydu. */
    function uygula() {
      if (baslik.classList.contains('sticky')) {
        if (dogalYukseklik) {
          kap.style.minHeight = dogalYukseklik + 'px';
        } else {
          /* Sayfa zaten kaydırılmış açıldı; akıştaki yüksekliği hiç
             göremedik. Sabit haldeki ölçü geçici rezerv olsun — tam
             doğru değil ama sıçramayı 93px'ten ~12px'e indiriyor. */
          var gecici = Math.round(baslik.getBoundingClientRect().height);
          if (gecici) kap.style.minHeight = gecici + 'px';
        }
        return;
      }
      /* Akıştayken: kendi rezervimiz ölçümü etkilemesin diye önce temizle.
         Başlık zaten o yüksekliği kapladığı için bu bir titremeye yol açmaz. */
      kap.style.minHeight = '';
      var h = Math.round(baslik.getBoundingClientRect().height);
      /* En BÜYÜK ölçüm tutuluyor. Sebep: tepeye dönerken .sticky sınıfı
         kalkar kalkmaz ölçüyoruz ama CSS geçişi henüz bitmemiş oluyor ve
         81px okunabiliyor. O değer rezerve yazılırsa bir sonraki kaydırmada
         12px'lik sıçrama geri geliyor. Akıştaki hâl her zaman en uzun hâl.
         Kırılım değişirse resize/fonts kancaları bunu sıfırlıyor. */
      if (h > dogalYukseklik) dogalYukseklik = h;
      if (dogalYukseklik) kap.style.minHeight = dogalYukseklik + 'px';
    }

    uygula();

    /* Sınıf değişimini izle: tema .sticky'yi ekleyip çıkarıyor. */
    if (window.MutationObserver) {
      new MutationObserver(uygula).observe(baslik, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    /* Ekran döndürme / yeniden boyutlama: kırılım değişince başlığın akıştaki
       yüksekliği de değişiyor (mobil 60 / masaüstü 93). Yalnızca sabit
       DEĞİLKEN yeniden ölçebiliyoruz; sabitken eski rezerv korunur ve
       kullanıcı tepeye döndüğünde kendiliğinden tazelenir. */
    var zamanlayici = null;
    window.addEventListener('resize', function () {
      clearTimeout(zamanlayici);
      zamanlayici = setTimeout(function () {
        if (!baslik.classList.contains('sticky')) dogalYukseklik = 0;
        uygula();
      }, 150);
    });

    /* Yazı tipleri geç yüklenirse başlık birkaç piksel değişebiliyor. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!baslik.classList.contains('sticky')) dogalYukseklik = 0;
        uygula();
      });
    }
    window.addEventListener('load', uygula);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur, { once: true });
  } else {
    kur();
  }
})();
